/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './doctor-especialty.reducer';

export const DoctorEspecialtyDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const doctorEspecialtyEntity = useAppSelector(state => state.doctorEspecialty.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="doctorEspecialtyDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.doctorEspecialty.detail.title">DoctorEspecialty</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.doctorEspecialty.id">Id</Translate>
            </span>
          </dt>
          <dd>{doctorEspecialtyEntity.id}</dd>
          <dt>
            <span id="departmentCode">
              <Translate contentKey="tinyMedicRestApp.doctorEspecialty.departmentCode">Department Code</Translate>
            </span>
          </dt>
          <dd>{doctorEspecialtyEntity.departmentCode}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.doctorEspecialty.active">Active</Translate>
            </span>
          </dt>
          <dd>{doctorEspecialtyEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="createdDtm">
              <Translate contentKey="tinyMedicRestApp.doctorEspecialty.createdDtm">Created Dtm</Translate>
            </span>
          </dt>
          <dd>{doctorEspecialtyEntity.createdDtm}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.doctorEspecialty.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{doctorEspecialtyEntity.createdBy}</dd>
          <dt>
            <span id="modifiedBy">
              <Translate contentKey="tinyMedicRestApp.doctorEspecialty.modifiedBy">Modified By</Translate>
            </span>
          </dt>
          <dd>{doctorEspecialtyEntity.modifiedBy}</dd>
          <dt>
            <span id="joiningDt">
              <Translate contentKey="tinyMedicRestApp.doctorEspecialty.joiningDt">Joining Dt</Translate>
            </span>
          </dt>
          <dd>{doctorEspecialtyEntity.joiningDt}</dd>
          <dt>
            <span id="leavingDt">
              <Translate contentKey="tinyMedicRestApp.doctorEspecialty.leavingDt">Leaving Dt</Translate>
            </span>
          </dt>
          <dd>{doctorEspecialtyEntity.leavingDt}</dd>
          <dt>
            <span id="consultationCharge">
              <Translate contentKey="tinyMedicRestApp.doctorEspecialty.consultationCharge">Consultation Charge</Translate>
            </span>
          </dt>
          <dd>{doctorEspecialtyEntity.consultationCharge}</dd>
          <dt>
            <span id="followupCharge">
              <Translate contentKey="tinyMedicRestApp.doctorEspecialty.followupCharge">Followup Charge</Translate>
            </span>
          </dt>
          <dd>{doctorEspecialtyEntity.followupCharge}</dd>
          <dt>
            <span id="followupDay">
              <Translate contentKey="tinyMedicRestApp.doctorEspecialty.followupDay">Followup Day</Translate>
            </span>
          </dt>
          <dd>{doctorEspecialtyEntity.followupDay}</dd>
          <dt>
            <span id="followupVisit">
              <Translate contentKey="tinyMedicRestApp.doctorEspecialty.followupVisit">Followup Visit</Translate>
            </span>
          </dt>
          <dd>{doctorEspecialtyEntity.followupVisit}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.doctorEspecialty.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{doctorEspecialtyEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.doctorEspecialty.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{doctorEspecialtyEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.doctorEspecialty.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{doctorEspecialtyEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.doctorEspecialty.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{doctorEspecialtyEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorEspecialty.doctorId">Doctor Id</Translate>
          </dt>
          <dd>{doctorEspecialtyEntity.doctorId ? doctorEspecialtyEntity.doctorId.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorEspecialty.especialtyCode">Especialty Code</Translate>
          </dt>
          <dd>{doctorEspecialtyEntity.especialtyCode ? doctorEspecialtyEntity.especialtyCode.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/doctor-especialty" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/doctor-especialty/${doctorEspecialtyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DoctorEspecialtyDetail;
